import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const FacetLogoPrimary = props => (
  <SvgIcon viewBox="0 0 283.5 76.5" x="0px" y="0px" {...props}>
    <g id="Facet">
      <g>
        <path
          fill="#007099"
          d="M131.7,31.8c5.6,0,10.4,2.8,13.2,6.8l7.8-7.8c-4.7-5.6-12-9.7-21-9.7c-15.2,0-26.9,12-26.9,26.9s11.7,26.9,26.9,26.9c9.1,0,16.4-4.1,21-9.7l-7.8-7.8c-2.8,3.9-7.6,6.8-13.2,6.8c-8.8,0-15.2-7-15.2-16.2S123,31.8,131.7,31.8z"
        />
        <polygon
          fill="#007099"
          points="12.1,11.9 36.3,11.9 48.2,0 0,0 0,74 12.1,74 12.1,42.3 27.5,42.3 39.1,30.6 12.1,30.6"
        />
        <path
          fill="#007099"
          d="M184.4,21c-15.1,0-26.3,11.7-26.3,26.9c0,15.4,11.9,26.9,26.7,26.9c9.6,0,17.4-4.2,22-9.9l-7.8-7.7c-2.7,4-8.1,7-14.2,7c-7.3,0-14.4-5-15.2-13.9h40.2c0-0.7,0-1.3,0-1.9C209.9,32,199.4,21,184.4,21z M170,42c1.8-8.1,8.4-11.2,13.9-11.2c6.9,0,12.8,3.8,13.9,11.2H170z"
        />
        <path
          fill="#007099"
          d="M83.8,26.4c-3.8-3.4-9.1-5.3-14.7-5.3c-15.3,0-26,12.1-26,26.9s10.7,26.9,26,26.9c5.6,0,10.9-1.8,14.7-5.2V74h11.5V21.9H83.8V26.4z M83.8,57.3c-2.7,4.1-7.4,6.9-13.5,6.9c-9.3,0-15.5-7.2-15.5-16.2s6.2-16.3,15.5-16.3c6.2,0,10.9,2.8,13.5,7V57.3z"
        />
        <path
          fill="#007099"
          d="M238.2,56.1v-24h8.5l10.2-10.2h-18.7V7.7h-11.5v14.1h-5.6l-10.2,10.2h15.9v26.5c0,9.9,6,15.4,15.9,15.4h3L256,63.6h-10.7C240.1,63.6,238.2,60.9,238.2,56.1z"
        />
        <polygon fill="#FF9100" points="272.8,55.2 262,65.9 272.8,76.5 283.5,65.9" />
      </g>
    </g>
  </SvgIcon>
);

export default FacetLogoPrimary;
